"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cosseria": {
    "ec9b2705": [{
      "hkey": "e49299e5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cosseria": [{
      "hkey": "e49299e5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b5bd8125": [{
      "hkey": "958f29e8",
      "slug": "cosseria",
      "name": "Cosseria",
      "primary": true,
      "skipSearch": false
    }],
    "montecala": [{
      "hkey": "958f29e8",
      "slug": "cosseria",
      "name": "Cosseria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69ade9bc": [{
      "hkey": "958f29e8",
      "slug": "cosseria",
      "name": "Cosseria",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "958f29e8",
      "slug": "cosseria",
      "name": "Cosseria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;